import React, { FC } from 'react';

import Image from 'next/image';

import ContractIcon from '@/assets/help-center/contract.svg';

import styles from './DocumentCard.module.scss';
type Props = {
	title: string;
	description?: string;
	url?: string;
};

export const DocumentCard: FC<Props> = ({ title, description, url }) => {
	return (
		<a href={url} target="_blank" rel="noreferrer" className={styles.container}>
			<Image
				className={styles.icon}
				width={72}
				height={72}
				src={ContractIcon}
				alt="Contract"
			/>
			<div className={styles.info}>
				<div className={styles.title}>{title}</div>
				{description && <div className={styles.description}>{description}</div>}
			</div>
		</a>
	);
};
